import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-denglujilu",
  "use": "icon-denglujilu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-denglujilu\"><path d=\"M7.952.135C3.715.135.268 3.578.268 7.809c0 4.232 3.447 7.675 7.684 7.675s7.684-3.443 7.684-7.675c0-4.23-3.447-7.674-7.684-7.674zm0 14.584a6.917 6.917 0 01-6.91-6.91C1.042 4 4.142.9 7.952.9s6.91 3.1 6.91 6.91c-.002 3.81-3.1 6.91-6.91 6.91zm4.44-7.055L9.187 4.456c-.079-.078-.25-.038-.38.09-.13.13-.17.3-.09.38l2.529 2.529H3.822a.355.355 0 000 .71l7.424-.001-2.529 2.529c-.079.078-.038.25.09.38.13.13.3.17.38.09l3.207-3.208a.141.141 0 00.04-.096.898.898 0 000-.101.152.152 0 00-.042-.094z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/denglujilu.svg
// module id = 455
// module chunks = 4